import React from 'react'
import Modal from 'react-modal'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import { Editor } from '@tinymce/tinymce-react'

import CommError from '../../Shared/Errors/Errors'

import './CreateEditLocation.css'

const styling = {
    content: {
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        maxWidth: 'none',
        paddingTop: '0px',
        background: 'white',
        paddingLeft: '50px',
        paddingRight: '40px'
    }
}

const formatTime = (timeString, isClose) => {
    if (!timeString || timeString.indexOf(':') < 0 || timeString.length === 5)
        return timeString;
    
    const timeParts = timeString.split(':');

    if (isClose)
        timeParts[0] = (parseInt(timeParts[0]) + 12).toString();

    if (timeParts[0].length === 1)
        timeParts[0] = "0" + timeParts[0];
    
    return timeParts.join(':');
}

const CreateEditLocation = (
    {
        errLocation,
        errLocationClear,

        curLocation,
        tmpLocation,
        locationGroups,

        states,

        create,
        isOpen,
        viewOnly,

        onPageDescChange,

        onAfterOpen,
        onRequestClose,
        onRequestCancel,

        locationCheck
    }) => {
        const location = create ? curLocation : tmpLocation,
              { weekdayHours, weekendHours } = location;

        let { openingHours } = location;
        if (!openingHours || typeof openingHours === 'undefined') {
            openingHours = {};

            const daysPart = 'Mon-Fri ';
            let weekdayOpen = '',
                weekdayClose = '';

            if (weekdayHours && weekdayHours.indexOf(daysPart) === 0) {
                const hourParts = weekdayHours.replace(daysPart, '').split(' - ');
                weekdayOpen = hourParts[0];
                weekdayClose = hourParts[1];
            }
            
            openingHours.weekdays = {
                opens: weekdayOpen,
                closes: weekdayClose
            };

            let saturdayOpen = '',
                saturdayClose = '',
                sundayOpen = '',
                sundayClose = '';

            if (weekendHours !== '') {
                if (weekendHours.indexOf('Sat-Sun ') === 0) {
                    const hourParts = weekendHours.replace('Sat-Sun ', '').split(' - ');
                    saturdayOpen = hourParts[0];
                    saturdayClose = hourParts[1];
                    sundayOpen = hourParts[0];
                    sundayClose = hourParts[1];
                } else if (weekendHours.indexOf('Sat ') === 0) {
                    const hourParts = weekendHours.replace('Sat ', '').split(' - ');
                    saturdayOpen = hourParts[0];
                    saturdayClose = hourParts[1];
                } else if (weekendHours.indexOf('Sun ') === 0) {
                    const hourParts = weekendHours.replace('Sun ', '').split(' - ');
                    sundayOpen = hourParts[0];
                    sundayClose = hourParts[1];
                }
            }

            openingHours.saturday = {
                opens: saturdayOpen,
                closes: saturdayClose
            };
            openingHours.sunday = {
                opens: sundayOpen,
                closes: sundayClose
            };
        }

        return (
            <Modal isOpen={isOpen} onAfterOpen={onAfterOpen} onRequestClose={onRequestClose} style={styling}>
                <CommError error={errLocation.error} onClose={errLocationClear} />

                <div className="create-edit-location editpages productManagement">
                    <div className="form-group">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-6 heading">
                                    <h1>{create ? viewOnly ? 'View' : 'Edit' : 'Create'} Location</h1>
                                    <p className="required">*= Required to Publish</p>
                                </div>
                                <div className="col-md-6 button-options-container">
                                    <div className="button-options first">
                                        <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
                                        <button className="btn btn-primary location publish" create={create ? "false" : "true"} onClick={onRequestClose}>Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 header">
                            <div className="col-md-5">
                                <p>Name:*</p>
                                <input id="name_2" defaultValue={create ? curLocation.name : tmpLocation.name} onChange={locationCheck} />                               
                            </div>
                            <div className="col-md-5">
                                <p>Location Description:*</p>
                                <input id="locationDescription" defaultValue={create ? curLocation.locationDescription : tmpLocation.locationDescription} onChange={locationCheck} />                               
                            </div>
                            <div className="col-md-2">
                                <p>Reico ID:*</p>
                                <input id="reicoId" defaultValue={create ? curLocation.reicoId : tmpLocation.reicoId} onChange={locationCheck} />                               
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="location-blk">
                                <p className="location-blk-hdg">Location SEO Information</p>

                                <div className="row child-row">
                                    <div className="col-md-12">
                                        <div className="col-md-4 ispub">
                                            <span>Location Page Published: </span>
                                            <input type="checkbox" id="locationPagePublished" defaultChecked={create ? curLocation.locationPagePublished : tmpLocation.locationPagePublished} onChange={locationCheck} />
                                            <span className="req-msg">Some required fields are missing - check entire form</span>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Location Page Title:*</p>
                                        <input id="locationPageTitle" defaultValue={create ? curLocation.locationPageTitle : tmpLocation.locationPageTitle} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>Location Page URL:*</p>
                                        <input id="locationPageUrl" defaultValue={create ? curLocation.locationPageUrl : tmpLocation.locationPageUrl} onChange={locationCheck} />                               
                                    </div>
                                </div>

                                <div className="row child-row">
                                    <div className="col-md-12">
                                        <p>Location Page Description:*</p>
                                        <Editor initialValue={create ? curLocation.locationPageDescription : tmpLocation.locationPageDescription}
                                            init={
                                                {
                                                    menubar: false,
                                                    branding: false,
                                                    elementpath: false,
                                                    init_instance_callback: onPageDescChange,
                                                    plugins: "lists advlist link image textcolor table hr code",
                                                    toolbar: viewOnly ? false : "bold italic underline forecolor backcolor | styleselect numlist bullist | fontselect | fontsizeselect | link image | alignleft aligncenter alignright alignjustify | table hr code"
                                                }
                                            }
                                            apiKey="8e64hzacbayfd5osxbwkwtn1120t8xrh7wg526cs6ox73d3e"
                                        />
                                    </div>
                                </div>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>Location Page Meta Description:*</p>
                                            <input id="locationPageMetaDescription" defaultValue={create ? curLocation.locationPageMetaDescription : tmpLocation.locationPageMetaDescription} onChange={locationCheck} />
                                            <p id="locationPageMetaDescriptionCounter" className="counters"></p>
                                    </div>
                                    <div className="col-md-6">
                                        <p>Location Page Meta Title:*</p>
                                            <input id="locationPageMetaTitle" defaultValue={create ? curLocation.locationPageMetaTitle : tmpLocation.locationPageMetaTitle} onChange={locationCheck} />                               
                                            <p id="locationPageMetaTitleCounter" className="counters"></p>
                                    </div>
                                </div>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>Latitude:*</p>
                                        <input id="latitude" defaultValue={create ? curLocation.latitude : tmpLocation.latitude} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>Longitude:*</p>
                                        <input id="longitude" defaultValue={create ? curLocation.longitude : tmpLocation.longitude} onChange={locationCheck} />                               
                                    </div>
                                </div>

                                <div className="row child-row">
                                    <div className="col-md-12">
                                        <p>Virtual Tour Link:</p>
                                        <textarea id="virtualTourLink" defaultValue={create ? curLocation.virtualTourLink : tmpLocation.virtualTourLink} onChange={locationCheck} />                               
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="location-blk">
                                <p className="location-blk-hdg">Location Menu Information</p>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>Menu Display Order:*</p>
                                        <input id="displayOrder" defaultValue={create ? curLocation.displayOrder : tmpLocation.displayOrder} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>Location Group:*</p>
                                        <select id="locationGroupId" defaultValue={create ? curLocation.locationGroupId : tmpLocation.locationGroupId} onChange={locationCheck} >
                                            <option>Select</option>
                                            {
                                                locationGroups ?
                                                    locationGroups
                                                        .filter((locGrp) => { return locGrp.isActive })
                                                        .map((opt, index) => {
                                                            return <option value={opt.id} key={index}>{opt.name}</option>
                                                        })
                                                :
                                                    null
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="location-blk">
                                <p className="location-blk-hdg">Location Address Information</p>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>Address 1:*</p>
                                        <input id="addressLine1" defaultValue={create ? curLocation.addressLine1 : tmpLocation.addressLine1} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>Address 2</p>
                                        <input id="addressLine2" defaultValue={create ? curLocation.addressLine2 : tmpLocation.addressLine2} />                               
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p>City:*</p>
                                        <input id="city" defaultValue={create ? curLocation.city : tmpLocation.city} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-4">
                                        <p>State:*</p>
                                        <select id="stateCode" defaultValue={create ? curLocation.stateCode : tmpLocation.stateCode} onChange={locationCheck} >
                                            <option>Select</option>
                                            {
                                                states ?
                                                    states.map((st, index) => {
                                                        return <option key={index}>{st.code}</option>
                                                    })
                                                : null
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <p>Zip:*</p>
                                        <input id="zip" defaultValue={create ? curLocation.zip : tmpLocation.zip} onChange={locationCheck} />                               
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p>Country:*</p>
                                        <input id="countryCode" defaultValue={create ? curLocation.countryCode : "United States"} onChange={locationCheck} />
                                    </div>
                                    <div className="col-md-4">
                                        <p>Phone:*</p>
                                        <input id="phone" defaultValue={create ? curLocation.phone : tmpLocation.phone} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-4">
                                        <p>Fax:*</p>
                                        <input id="fax" defaultValue={create ? curLocation.fax : tmpLocation.fax} onChange={locationCheck} />                               
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-4">
                                        <p>Email:*</p>
                                        <input id="email" defaultValue={create ? curLocation.email : tmpLocation.email} onChange={locationCheck} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="location-blk">
                                <p className="location-blk-hdg">Location Hours of Operation Information</p>

                                <div className="row child-row">
                                    <div className="col-md-2">
                                        <p><strong>Day of Week</strong></p>
                                        <p>Monday - Friday</p>
                                        <p>Saturday</p>
                                        <p>Sunday</p>
                                    </div>
                                    <div className="col-md-1">
                                        <p><strong>Open Time</strong></p>
                                        <input className="mb-1" id="weekdayOpenTime" defaultValue={formatTime(openingHours.weekdays.opens, false)} type="time" onChange={locationCheck} />
                                        <input className="mb-1" id="saturdayOpenTime" defaultValue={formatTime(openingHours.saturday.opens, false)} type="time" onChange={locationCheck} />
                                        <input className="mb-1" id="sundayOpenTime" defaultValue={formatTime(openingHours.sunday.opens, false)} type="time" onChange={locationCheck} />
                                    </div>
                                    <div className="col-md-1">
                                        <p><strong>Close Time</strong></p>
                                        <input className="mb-1" id="weekdayCloseTime" defaultValue={formatTime(openingHours.weekdays.closes, true)} type="time" onChange={locationCheck} />
                                        <input className="mb-1" id="saturdayCloseTime" defaultValue={formatTime(openingHours.saturday.closes, true)} type="time" onChange={locationCheck} />
                                        <input className="mb-1" id="sundayCloseTime" defaultValue={formatTime(openingHours.sunday.closes, true)} type="time" onChange={locationCheck} />
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-12">
                                        <p>Location Hours Notes:</p>
                                        <textarea id="locationHoursNotes" defaultValue={create ? curLocation.locationHoursNotes : tmpLocation.locationHoursNotes} onChange={locationCheck} />
                                    </div>
                                </div>
                                <div className="row child-row">
                                    <div className="col-md-12">
                                        <div className="col-md-4 notes">
                                            <span>Is Closed</span>
                                            <input type="checkbox" id="isClosed" defaultChecked={create ? curLocation.isClosed : tmpLocation.isClosed} />
                                            <br/>
                                            <span>Notes:</span>
                                        </div>
                                        <textarea id="isClosedNotes" defaultValue={create ? curLocation.isClosedNotes : tmpLocation.isClosedNotes} onChange={locationCheck} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="location-blk">
                                <p className="location-blk-hdg">Reico Location Information</p>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>Hub:*</p>
                                        <input id="hub" defaultValue={create ? curLocation.hub : tmpLocation.hub} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>Team:*</p>
                                        <input id="team" defaultValue={create ? curLocation.team : tmpLocation.team} onChange={locationCheck} />                               
                                    </div>
                                </div>

                                <div className="row child-row">
                                    <div className="col-md-6">
                                        <p>PC:*</p>
                                        <input id="pc" defaultValue={create ? curLocation.pc : tmpLocation.pc} onChange={locationCheck} />                               
                                    </div>
                                    <div className="col-md-6">
                                        <p>IP:*</p>
                                        <input id="ip" defaultValue={create ? curLocation.ip : tmpLocation.ip} onChange={locationCheck} />                               
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <div className="col-md-12 button-options-container">
                            <div className="button-options">
                                <a className="btn btn-default" onClick={onRequestCancel} >Cancel</a>
                                <button className="btn btn-primary location publish" create={create ? "false" : "true"} onClick={onRequestClose}>Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
}

// Modal.setAppElement('body');
        
export default CreateEditLocation